import { ref, deleteObject } from 'firebase/storage';
import { storage } from './firebase';
import { getStoragePathFromDownloadUrl } from '../utils/catalogProductImageStorage';

const isIgnorableDeleteError = (error) => error?.code === 'storage/object-not-found';

/**
 * Remove arquivo do Storage a partir da download URL salva em catalogImage.url.
 * Falhas de objeto inexistente são ignoradas (já removido ou legado externo).
 */
export async function deleteStoredCatalogProductImage(downloadUrl) {
  const storagePath = getStoragePathFromDownloadUrl(downloadUrl);
  if (!storagePath) return;

  try {
    await deleteObject(ref(storage, storagePath));
  } catch (error) {
    if (isIgnorableDeleteError(error)) return;
    console.warn('Não foi possível excluir imagem antiga da vitrine:', error);
  }
}
